import React, { useState } from "react";
import { TextField } from "@mui/material";
import { MobileDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const CustomDatePicker = ({ open, date, index, field, handleChange, handleBlur }) => {
    const [currDate, setCurrDate] = useState(date ? date : "");
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
                open={open}
                onClose={() => handleBlur()}
                views={["year", "month", "day"]}
                value={currDate ? dayjs(currDate) : ""}
                onChange={(date) => setCurrDate(date.format("YYYY-MM-DD"))}
                onAccept={async (date) => {
                    await handleChange(index, field, date.format("YYYY-MM-DD"));
                    handleBlur(date.format("YYYY-MM-DD"));
                }}
                format={"YYYY-MM-DD"}
                renderInput={(params) => <TextField {...params} />}
                slotProps={{
                    dialog: {
                        onClose: (event, reason) => {
                            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                                handleBlur();
                            }
                        },
                    },
                    textField: { style: { display: "none" } },
                }}
            />
        </LocalizationProvider>
    );
};

export default CustomDatePicker;